import React, { useEffect, useState } from 'react'
import { Navigate } from '@tanstack/react-router'
import { UserServiceUserType } from '@/types/user'
import { useAuthServiceKratosMeLazyQuery } from 'zma-react-sdk/auth-service'
import { useAuth } from '@/stores/authStore'

interface AdminProtectedRouteProps {
  children: React.ReactNode
}

export const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({
  children,
}) => {
  const auth = useAuth()
  const [isLoading, setIsLoading] = useState(true)

  const [getMe] = useAuthServiceKratosMeLazyQuery({
    onCompleted: (data) => {
      if (data?.authServiceKratosMe) {
        auth.setUser({
          id: data.authServiceKratosMe.id,
          email: data.authServiceKratosMe.email || '',
          firstName: data.authServiceKratosMe.firstName || '',
          lastName: data.authServiceKratosMe.lastName || '',
          fullName: `${data.authServiceKratosMe.firstName} ${data.authServiceKratosMe.lastName}`,
          status: data.authServiceKratosMe.status as any,
          type: data.authServiceKratosMe.type as any,
        })
      }
      setIsLoading(false)
    },
    onError: () => {
      auth.reset()
      setIsLoading(false)
    },
  })

  useEffect(() => {
    if (auth.accessToken && auth.refreshToken) {
      getMe()
    } else {
      setIsLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div className='flex min-h-screen items-center justify-center'>
        <div className='h-8 w-8 animate-spin rounded-full border-b-2 border-primary'></div>
      </div>
    )
  }

  // If not authenticated, redirect to sign-in with current location as redirect
  if (!auth.isAuthenticated) {
    return <Navigate to='/sign-in' replace />
  }

  // Check if user is admin or agency
  if (
    auth.user?.type !== UserServiceUserType.Admin &&
    auth.user?.type !== UserServiceUserType.Agency
  ) {
    return <Navigate to='/' replace />
  }

  // If authenticated and admin or agency, render children
  return <>{children}</>
}
